var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.type && _vm.models)?_c('b-container',{attrs:{"fluid":""}},[_c('page-title',{attrs:{"icon":"fas fa-cogs"}},[_c('translate',[_vm._v("Shipment Task Hooks")])],1),_vm._v(" "),_c('api-list',{attrs:{"type":"shippingTaskHooks","model":_vm.models.shippingTaskHooks,"hideFilters":"","page-options":[1, 5, 10, 25, 50, 100, 150]}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }